import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-projectMore',
  templateUrl: 'projectMore.html',
})
export class ProjectMorePage {
  private projects = [];
  private work: any;
  private tasks = [];
  private desc: any;
  private title: any;
  config1: any;
  private beginDate: any;
  private endDate: any;
  private GetWorks = [];
  private tabIndex = 1;
  private date: any;
  private Dates = [];
  private GetUsersTimes = [];
  private GetUsersTimesByDate = [];
  private dateBegin: any;
  private dateEnd: any;
  private amarsanDateCount = [];
  private chuluuDateCount = [];
  private chuluuDateCount1 = [];
  private chuluuDateCount2 = [];
  private UndsenDays = 0;
  private ajilsanDays = 0;
  private jobCoreTime = 0;
  private undsenTime = 0;
  private ajillasanTime = 0.0;
  private iluuTime = 0.0;
  private Amarsan = 0;
  private ButenChuluu = 0;
  private UdesOmnoh = 0;
  private UdesHoish = 0;
  private projectUsageTime = 0;
  private projectTotalSpendTime = 0;
  private projectTotalSpendProcess = 0;
  private taskUsageTime = 0;
  private taskTotalSpendTime = 0;
  private taskTotalSpendProcess = 0;
  private taskTotalSpendProcessDate = 0;
  private sDate: any;
  private fDate: any;
  private merge = [];
  private merge1 = [];
  private holiday = [];
  private chuluDateCount = 0;
  private chuluu = [];
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

      this.config1 = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.projects.length
      };
  }

  pageChanged(event){
    this.config1.currentPage = event;
  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Төслийн тайлан';
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    this.rest.Dates(this.data.companyId).subscribe(res => {
      this.Dates = res;
      for(let i = 0; i < this.Dates.length;i++) {
        if(this.Dates[i].begin_day <= nowdate && this.Dates[i].end_day >= nowdate) {
          this.date = this.Dates[i].id;
        }
        if(this.Dates[i].begin_day <= nowdate) {
          this.beginDate = this.Dates[i].begin_day;
          this.endDate = this.Dates[i].end_day;
          // console.log(this.beginDate);
          // console.log(this.endDate);
        }
      }
    });
    this.project();
  }

  setTabIndex(id: any) {
    this.tabIndex = id;
    if(this.tabIndex == 1) {
      this.project();
    } else if(this.tabIndex == 2) {
      this.task();
    } else if(this.tabIndex == 3) {
      this.users();
    }
  }

  tablesToExcel1() {
    let txt = '';
    //if(this.tabIndex == 3) {
    //  txt = document.getElementById('usersExcelDate').innerHTML;
    //}
    (window as any).tablesToExcel1(this.tabIndex, this.beginDate, this.endDate, txt);
  }


  project(){
    this.projectUsageTime = 0;
    this.projectTotalSpendTime = 0;
    this.projectTotalSpendProcess = 0;
    this.merge1 = [];
    this.rest.GetWorks(this.data.companyId, null, null).subscribe(res => {
      this.projects = res;
      for(let t=0;t<res.length;t++) {
        this.projectUsageTime = this.projectUsageTime + parseFloat(res[t].usage_time);
        this.projectTotalSpendTime = this.projectTotalSpendTime + parseFloat(res[t].total_spend_time);
        this.projectTotalSpendProcess = this.projectTotalSpendProcess + parseFloat(res[t].total_spend_process);
        res.sort((a, b) => a.customer_name.localeCompare(b.customer_name, 'es', {sensitivity: 'base'}));
        setTimeout(() => {
          (window as any).merge1();
        }, 1500);
      }
      this.search(event);
    });
  }

  task(){
    this.taskUsageTime = 0;
    this.taskTotalSpendTime = 0;
    this.taskTotalSpendProcess = 0;
    this.taskTotalSpendProcessDate = 0;
    this.merge = [];
    this.rest.GetAllTasks(this.data.companyId, this.beginDate, this.endDate).subscribe(res => {
      this.tasks = res;
      for(let i=0;i<res.length;i++) {
        if(res[i].spend_process_date != null){
          res[i].spend_process_date;
        } else if (res[i].spend_process_date == null){
          res[i].spend_process_date = 0;
        }
        if(res[i].total_spend_time != null){
          res[i].total_spend_time;
        } else if (res[i].total_spend_time == null){
          res[i].total_spend_time = 0;
        }
        if(res[i].spend_process_time != null){
          res[i].spend_process_time;
        } else if (res[i].spend_process_time == null){
          res[i].spend_process_time = 0;
        }
        this.taskUsageTime = this.taskUsageTime + parseFloat(res[i].usage_time);
        this.taskTotalSpendProcessDate = this.taskTotalSpendProcessDate + parseFloat(res[i].spend_process_date);
        this.taskTotalSpendTime = this.taskTotalSpendTime + parseFloat(res[i].total_spend_time);
        this.taskTotalSpendProcess= this.taskTotalSpendProcess + parseFloat(res[i].spend_process_time);
        // Task - project name sort
        // res[i].project_name;
        res.sort((a, b) => a.project_name.localeCompare(b.project_name, 'es', {sensitivity: 'base'}));
        setTimeout(() => {
          (window as any).merge();
          //(window as any).merge();
        }, 1500);
      }
    });
  }


  users() {
    this.UndsenDays = 0;
    this.ajilsanDays = 0;
    this.jobCoreTime = 0;
    this.undsenTime = 0;
    this.ajillasanTime = 0.0;
    this.iluuTime = 0.0;
    this.Amarsan = 0;
    this.ButenChuluu = 0;
    this.UdesOmnoh = 0;
    this.UdesHoish = 0;
    this.amarsanDateCount = [];
    this.chuluuDateCount = [];
    this.chuluuDateCount1 = [];
    this.chuluuDateCount2 = [];
    this.GetUsersTimesByDate = [];
    this.chuluDateCount = 0;
    this.holiday = [];
    this.chuluu = [];
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
          ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
          ('0' + now.getDate().toString()).slice(-2);
    this.rest.GetUsersTimesByDate(this.data.companyId, this.date, this.beginDate, this.endDate).subscribe(res => {

    for(let i=0;i<res.times.length;i++) {
      if (res.times[i].work_day > 0) {
        this.GetUsersTimesByDate.push(res.times[i]);
      }
    }

    //this.GetUsersTimesByDate = res;
    this.dateBegin = res.times[0].all_times[0].date;
    this.dateEnd = res.times[0].all_times[res.times[0].all_times.length - 1].date;
    // console.log(this.dateBegin);
    // console.log(this.dateEnd);
    for(let i=0;i<this.GetUsersTimesByDate.length;i++) {
      this.UndsenDays = this.UndsenDays + this.GetUsersTimesByDate[i].undsen_day;
      this.ajilsanDays = this.ajilsanDays + this.GetUsersTimesByDate[i].work_day;
      this.jobCoreTime = this.jobCoreTime + this.GetUsersTimesByDate[i].core_day;
      this.undsenTime = this.undsenTime + this.GetUsersTimesByDate[i].undsen_time;
      this.ajillasanTime = this.ajillasanTime + this.GetUsersTimesByDate[i].work_time;
      this.iluuTime = this.iluuTime + this.GetUsersTimesByDate[i].iluu_time;
      if(this.GetUsersTimesByDate[i].amralt.length > 0) {
        for(let j=0;j<this.GetUsersTimesByDate[i].amralt.length;j++) {
          if(this.GetUsersTimesByDate[i].amralt.begin_date <= nowdate && this.GetUsersTimesByDate[i].amralt.end_date >= nowdate){
            this.amarsanDateCount.push(this.GetUsersTimesByDate[i].amralt[j].holiday_count);
          }
          else{
            this.amarsanDateCount.push(0);
          }
        }
      } else {
        this.amarsanDateCount.push(0);
      }
      // // sard ni zahiragddag bolgoh
      // if(this.GetUsersTimesByDate[i].chuluu.forgot_date <= nowdate && this.GetUsersTimesByDate[i].chuluu.end_date >= nowdate){
      if (this.GetUsersTimesByDate[i].chuluu.length > 0) {
        let ch = 0, ch1 = 0, ch2 = 0, c = 0;
        // for (let j=0;j<this.GetUsersTimesByDate[i].chuluu.length;j++) {
          // for (let l=0;l<this.GetUsersTimesByDate[l].all_times.length;l++) {
          for (let a=0;a<this.GetUsersTimesByDate[i].all_times.length;a++) {
            // console.log(this.GetUsersTimesByDate[i].all_times);
            if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime != null) {
              // console.log(this.GetUsersTimesByDate[i].all_times[a].chuluuTime);
              // for (let w=0;w<this.GetUsersTimesByDate[i].all_times[a].chuluuTime.length;w++) {
              //   console.log(this.GetUsersTimesByDate[i].all_times[a].chuluuTime);
              // for (var aa = new Date(this.beginDate); aa < new Date(this.endDate) ; aa.getDate() + 1) {
              //   c++;
              //   this.chuluu.push(c);
              //   console.log(this.chuluu);
              // }
                if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date >= this.beginDate
                  && this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date <= this.endDate) {
                    // if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date != this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date
                    //   && this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date <= this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date
                    //   ) {
                    //   c++;
                    //   this.chuluu.push(c);
                    //   console.log(this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date, this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date);
                    //   console.log(this.GetUsersTimesByDate[i].all_times[a].holiday == 1);
                    //   console.log(this.chuluu);
                    // }
                    // console.log(this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date, this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date);
                  if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date !=
                      this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date
                    && this.GetUsersTimesByDate[i].all_times[a].chuluuTime.is_solved == 1
                    && this.GetUsersTimesByDate[i].user_id == this.GetUsersTimesByDate[i].all_times[a].chuluuTime.user_id) {

                      // var fDate = new Date(this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date);
                      // var eDate = new Date(this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date);
                      // for(fDate; fDate < eDate; fDate.setDate(fDate.getDate() + 1)){
                      //   if(this.GetUsersTimesByDate[i].all_times[a].date == this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date){
                      //     alert(this.GetUsersTimesByDate[i].all_times[a].holiday);
                      //   }
                      // }

                      // if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date >= this.GetUsersTimesByDate[i].all_times[a].date
                      //   && this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date <= this.GetUsersTimesByDate[i].all_times[a].date
                      //   && this.GetUsersTimesByDate[i].all_times[a].holiday == 1) {
                      //   c++;
                      //   this.chuluu.push(c);
                      //   console.log(this.chuluu);
                      // }

                      var dropDate = new Date(this.GetUsersTimesByDate[i].all_times[a].chuluuTime.end_date);
                      var pickDate = new Date(this.GetUsersTimesByDate[i].all_times[a].chuluuTime.forgot_date);
                      // console.log(this.GetUsersTimesByDate[i].all_times[a].chuluuTime[w]);
                      var chuluuCount = dropDate.getDate() - pickDate.getDate();
                      ch = ch + chuluuCount;
                      // console.log(ch);
                  } else if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime.type_time == 'AM' && this.GetUsersTimesByDate[i].all_times[a].chuluuTime.is_solved == 1) {
                    ch1++;
                  } else if (this.GetUsersTimesByDate[i].all_times[a].chuluuTime.type_time == 'PM' && this.GetUsersTimesByDate[i].all_times[a].chuluuTime.is_solved == 1) {
                    ch2++;
                  }
                }
              // }
            }
          }
        // }

        this.chuluuDateCount.push(ch);
        // console.log(this.chuluuDateCount);
        this.chuluuDateCount1.push(ch1);
        this.chuluuDateCount2.push(ch2);
        // Prob


      } else {
        this.chuluuDateCount.push(0);
        this.chuluuDateCount1.push(0);
        this.chuluuDateCount2.push(0);
      }


    }

    for(let q=0;q<this.chuluuDateCount.length;q++) {
      this.ButenChuluu = this.ButenChuluu + this.chuluuDateCount[q];
    }
    for(let w=0;w<this.chuluuDateCount1.length;w++) {
      this.UdesOmnoh = this.UdesOmnoh + this.chuluuDateCount1[w];
    }
    for(let e=0;e<this.chuluuDateCount2.length;e++) {
      this.UdesHoish = this.UdesHoish + this.chuluuDateCount2[e];
    }

    // Prob
    for(let j=0;j<this.amarsanDateCount.length;j++) {
      this.Amarsan = this.Amarsan + this.amarsanDateCount[j];
    }
    });
  }

  search(event) {
    this.merge = [];
    this.merge1 = [];
    if(this.tabIndex == 1) {
      this.rest.GetWorks(this.data.companyId, this.beginDate, this.endDate).subscribe(res => {
        this.projects = res;
        this.projects = this.projects.filter((item) => {
            return (item.end_day) >= this.beginDate && (item.begin_day) <= this.beginDate || (item.begin_day) <= this.endDate;
        })
        this.projects.sort((a, b) => a.customer_name.localeCompare(b.customer_name, 'es', {sensitivity: 'base'}));
        setTimeout(() => {
          (window as any).merge1();
        }, 1500);
      });
    } else if(this.tabIndex == 2){
      this.rest.GetAllTasks(this.data.companyId, this.beginDate, this.endDate).subscribe(res => {
        this.tasks = res;
        this.tasks = this.tasks.filter((item) => {
            return (item.end_day) >= this.beginDate && (item.begin_day) <= this.beginDate || (item.begin_day) <= this.endDate;
        })
        this.tasks.sort((a, b) => a.project_name.localeCompare(b.project_name, 'es', {sensitivity: 'base'}));
        setTimeout(() => {
          (window as any).merge();
        }, 1500);
      });
    } else {
      this.rest.GetUsersTimesByDate(this.data.companyId, this.date, this.beginDate, this.endDate).subscribe(res => {
        this.GetUsersTimesByDate = res.times;
        res.times = res.times.filter((item) => {
            return (item.date) >= this.endDate && (item.date) <= this.beginDate || (item.date) <= this.date;
        })
        this.users();
      });
    }
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/projectMore/projectMore.ts